module.exports = __webpack_public_path__ + "img/hr-tree-06-c-leaves.88e51494.png";